import {ProjectFeatureFlag} from '../constants';
import {CurrentProject} from '../model-resources/projects';
import {featureSamplingUtils} from './feature-sampling';

const FAST_REPORT_ITERATION_ROLLOUT_PERCENTAGE = 50;

export function isFIWFeatureEnabled(currentProject: CurrentProject): boolean {
  return (
    currentProject &&
    (currentProject.hasFeatureFlag(ProjectFeatureFlag.FastIterationWorkflow) ||
      featureSamplingUtils.determineFeatureEligibility(
        currentProject.id.toString(),
        ProjectFeatureFlag.FastIterationWorkflow,
        FAST_REPORT_ITERATION_ROLLOUT_PERCENTAGE,
      ))
  );
}

export function incrementSaveAsNewReportName(currentReportName: string): string {
  // if we want to capture last digits w/ 1or2 chars after: \\d+(?=[\\W]?$)
  const lastNumberString = currentReportName.match(`\\d+$`)?.[0];
  const endingNumber = parseInt(lastNumberString, 10);
  if (isNaN(endingNumber)) {
    return `${currentReportName} 1`;
  } else {
    return `${currentReportName.slice(0, -lastNumberString.length)}${endingNumber + 1}`;
  }
}
